import { render } from "./KaraokePlayer.vue?vue&type=template&id=c5ce73dc"
import script from "./KaraokePlayer.vue?vue&type=script&lang=js"
export * from "./KaraokePlayer.vue?vue&type=script&lang=js"

import "./KaraokePlayer.vue?vue&type=style&index=0&id=c5ce73dc&lang=css"

import exportComponent from "../../sender/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__